import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { Typography, Grid, Box, styled } from "@mui/material"; //Se importan elementos de la librería material-ui

import { validationActions } from "../../store/actions"; //Acciones para redux
import { GenericContainerConfirm, Buttons, UseImage } from "../../components";
import { getReplaceTitle } from "../../utils";
import validationImageImg from "../../assets/validationImage.jpg";
import { useTranslation } from "react-i18next";

const RootStyle = styled(Box)(({ theme }) => ({
  backgroundColor: "#FFF",
  minHeight: "calc(100vh - 120px)",
  margin: "0px auto",
  position: "relative",
  display: "flex",
  flexDirection: "column",
  maxHeight: "100vh",
  width: "100%",
}));

const OutletWrapper = styled(Box)(({ theme }) => ({
  margin: "0px",
  backgroundColor: "#FFF",
  width: "100%",
  overflowY: "auto",
  [theme.breakpoints.down(1200)]: {
    margin: "0px",
  },
  [theme.breakpoints.down("sm")]: {
    margin: "0px",
  },
  [theme.breakpoints.down("xs")]: {
    margin: "0px",
  },
}));

const ContainerPrincipal = styled(Grid)(({ theme }) => ({
  margin: "0px 45px 0px 0px",
  display: "grid !important",
  gridTemplateColumns: "20% 60% 20%",
  gridAutoRows: "100vh !important",
  overflowY: "hidden !important",
  "&::-webkit-scrollbar": {
    width: "0",
    background: "transparent",
  },
  overflowX: "hidden",
  position: "fixed",
  top: 0,
  bottom: 0,
  width: "100%",
  [theme.breakpoints.only("xs")]: {
    gridTemplateColumns: "100%",
  },
  [theme.breakpoints.only("sm")]: {
    gridTemplateColumns: "10% 80% 10%",
  },
  [theme.breakpoints.only("md")]: {
    gridTemplateColumns: "15% 70% 15%",
  },
  [theme.breakpoints.only("lg")]: {
    gridTemplateColumns: "20% 60% 20%",
  },
  [theme.breakpoints.only("xl")]: {
    gridTemplateColumns: "20% 60% 20%",
  },
  background: "#f1f1f1",
}));

const LateralBox = styled(Box)(({ theme }) => ({
  background: "#f2f2f2",
  [theme.breakpoints.only("xs")]: {
    display: "none",
  },
  [theme.breakpoints.only("sm")]: {
    display: "block !important",
  },
  [theme.breakpoints.only("md")]: {
    display: "block !important",
  },
  [theme.breakpoints.only("lg")]: {
    display: "block !important",
  },
  [theme.breakpoints.only("xl")]: {
    display: "block !important",
  },
}));

export default function ConfirmAccountFormComponent(props) {
  const navigate = useNavigate();
  const { useState, useEffect } = React; //Hook para el state
  let { results } = useNavigate();
  let location = useLocation();
  const [activaPeticion, setActivaPeticion] = useState(false);
  const { t } = useTranslation();
  //Redux hooks
  const ActivateUser = useSelector((state) => state.PINActivateUser);
  // const notification = useSelector(state => state.ReSendNip)
  const dispatch = useDispatch();

  /*Comienzan métodos y escuchas de componente**/
  //Promesa general Init
  useEffect(() => {
    getReplaceTitle("Aceptación");
    console.log("imprime location: ", location);
    let params = location.search.replace("?", "").split("&");
    console.log("imprime params: ", params);
    if (params != undefined && params != null && params[0] != "") {
      let vUSER = params[0].split("=")[1];
      let vPIN = params[1].split("=")[1];

      let sendParams = {
        username: vUSER,
        PIN: vPIN,
      };
      console.log("Imprime parametros: ", activaPeticion, sendParams);
      if (!activaPeticion) {
        dispatch(validationActions.ValidatePINActivateUser(sendParams));
        setActivaPeticion(true);
      }
    }
  }, []);

  useEffect(() => {
    console.log("Imprime valores respuesta activar-----:  ", ActivateUser);
    if (
      ActivateUser.error != undefined &&
      ActivateUser.error != null &&
      activaPeticion
    ) {
      // alert('Error al intentar actilet el usuario: ' + ActivateUser.error)
      console.log(
        "Error al intentar actilet el usuario: " + ActivateUser.error
      );
    }
  }, [ActivateUser]);

  let submitLogin = (e) => {
    //Login
    e.preventDefault();
    navigate("/auth/");
  };

  //Comienza interfaz
  return (
    <>
      <UseImage src={validationImageImg} width="100%" />
      <GenericContainerConfirm sx={{ justifyContent: "center !important" }}>
        <Typography
          variant="h6"
          gutterBottom
          sx={{ width: "100%", textAlign: "center" }}
        >
          Cuenta activada correctamente
          {/* {t("cargar_account_activated_successfully")} */}
        </Typography>
        <Typography variant="subtitle1" gutterBottom>
          Para continuar con tu trámite deberás iniciar sesión en tu cuenta e
          ingresar el código de un solo uso que enviaremos por correo.
          {/* {t("cargar_continue_with_procedure")} */}
        </Typography>

        <Buttons
          onClickConfirm={submitLogin}
          ConfirmButtonText={"Iniciar sesión"}
          //   ConfirmButtonText={t("login_sign_in")}
        />
      </GenericContainerConfirm>
    </>
  );
}
